import { render, staticRenderFns } from "./CategoryMetricCard.vue?vue&type=template&id=00e38a18&scoped=true"
import script from "./CategoryMetricCard.vue?vue&type=script&lang=js"
export * from "./CategoryMetricCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryMetricCard.vue?vue&type=style&index=0&id=00e38a18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e38a18",
  null
  
)

export default component.exports